// extracted by mini-css-extract-plugin
export var container = "ProductFileLink-module--container--e448a";
export var details = "ProductFileLink-module--details--555ac";
export var text = "ProductFileLink-module--text--764c5";
export var thumb = "ProductFileLink-module--thumb--5ce36";
export var title = "ProductFileLink-module--title--f5d04";